export default defineNuxtRouteMiddleware((to) => {
  // TODO: check the launch-designer-state and redirect the user to dashboard or confirmation.
  const targetPath = '/liquidity-launch-designer/dashboard'
  if (to.path !== targetPath) {
    return navigateTo(targetPath)
  }
})
